<template>
  <div v-if="postModel" class="watchlist_container watchlist_post_container bg-dark-container" ref="col_watchlist">
    <div class="watchlist_table_body" v-if="postModel.prediction.length">
      <el-scrollbar>
        <div class="wathlistScrollContainer">
          <div class="predicition-post-card" v-for="item in postModel.prediction" :key="item.predictionId">
            <PredictionCardItem class="cursor-pointer" :postId="postModel._id" :trade="item" :disableRouting="false" />
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import PredictionCardItem from "@/views/private/profile-screen/components/Predictions/PredictionCardChartItem.vue";

export default defineComponent({
  components: {
    PredictionCardItem,
  },
  props: ["postModel"],
  setup(props) {
    onMounted(() => { });
    return {};
  },
});
</script>

<style lang="scss">
.watchlistItemContainerDv {
  margin-bottom: 15px;
}

.watchlist_table_body {
  .wathlistScrollContainer {
    max-height: calc(100vh - 350px) !important;
    height: auto;
  }
}

.boardPost {
  .watchlist_table_body {
    background: var(--base-dark);
    border-radius: 15px;
    padding: 15px;

    .wathlistScrollContainer {
      max-height: 340px;
    }
  }

  &.postDetails {
    max-width: 100%;
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 100%;
    padding: 10px 0;

    .watchlist_table_body {
      flex: 0 0 80%;
      max-width: 80%;
      max-height: 80%;
      overflow: auto;
      @include newScrollbar;

      .wathlistScrollContainer {
        max-height: none;
      }
    }
  }
}

.bg-dark-container {
  background: var(--base-dark);
  padding: 20px 10px;
  border-radius: 10px;
}

.watchlist_post_container {
  &.categorical {
    padding: 20px;
    border-radius: 10px;
    background: var(--secondary-background-color);
    height: 200px;

    .watchlist_table_head {
      width: unset;
      font-size: var(--font-xs);
      font-weight: 500;
      color: var(--text-color);
      margin-bottom: 10px;
    }
  }

  &[class*="prediction"] {
    border-radius: 10px;

    .watchlist_table_body {

      // padding: 16px 16px 8px;
      .watchlist_item {
        .remove {
          position: absolute;
          top: -5px;
          right: -5px;

          i {
            color: var(--color-negative);
          }
        }

        .change {
          font-size: var(--font-xs);
          color: var(--text-color);
          text-align: right;
          font-weight: 500;

          &_chip {
            font-size: var(--font-2xs);
            padding: 4px 6px;
            min-width: 50px;
            border-radius: 22px;
            background: var(--color-negative);
            text-align: center;
            margin-top: 5px;

            &.bearish {
              background: var(--bullish-light1);
            }
          }
        }

        p {
          &.price {
            margin: 0;
            line-height: 1;

            span {
              font-size: var(--font-2xs);
              color: var(--color-new-light-grey2);
              margin: 5px 0 0;
              font-weight: 400;

              &.heading {
                font-size: var(--font-5xs);
                color: var(--text-color);
                margin: 0 0 10px;
              }
            }

            &.right {
              text-align: right;
            }
          }
        }
      }

      &.watchlist_grid {
        .watchlist_grid_item {
          display: flex;
          align-items: center;
          padding: 0 40px 10px 10px;
          position: relative;

          >* {
            flex-grow: 1;
            max-width: 25%;

            &.expanded {
              flex: 0 0 34%;
              max-width: 34%;
            }

            &:not(.expanded) {
              flex: 0 0 22%;
              max-width: 22%;
            }
          }

          h6 {
            font-size: var(--font-2xs);
            color: var(--text-color);
            margin: 0;
            font-weight: 500;
          }

          p {
            color: var(--white-color);

            &.price {
              font-size: var(--font-xs);
              font-weight: 500;
              color: var(--white-color);

              span {
                display: block;
                font-size: var(--font-2xs);
              }
            }
          }

          .change {
            &_chip {
              width: max-content;
              margin-inline-start: auto;
            }
          }

          .remove {
            flex: none;
            position: absolute;
            right: 5px;
            top: 50%;
            transform: translateY(-50%);
          }

          &.watchlist_item {
            background: transparent linear-gradient(262deg, #6837b1 0%, #3a2667 100%) 0% 0% no-repeat padding-box;
            border-radius: 12px;
            padding-top: 10px;
          }
        }

        &.smallColSize {
          .watchlist_grid_item {
            padding-inline-end: 10px;

            >* {
              padding: 0 2px;
            }
          }

          .top_card_stock_detail {
            figure {
              width: 25px;
              height: 25px;
              flex: 0 0 25px;
              padding: 4px;
              display: flex;
              align-items: center;
              border-radius: 5px;
            }

            p:not(.price__tag) {
              font-size: var(--font-xs);

              span {
                font-size: var(--font-3xs);
              }
            }
          }

          p.price {
            span {
              font-size: var(--font-3xs);
            }
          }

          .change_chip {
            font-size: var(--font-3xs);
          }
        }
      }
    }
  }

  &.text-prediction {
    .watchlist_table_body {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -20px -20px 0;

      .watchlist_item {
        position: relative;
        min-height: 140px;
        width: 260px;
        margin: 0 20px 20px 0;
        padding-bottom: 30px;

        >.sparkline_container {
          opacity: 0.4;
          min-height: 45%;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
        }

        .top_card_stock_detail {
          align-items: flex-start;

          p {
            font-size: var(--font-2xs);

            span:not(.heading) {
              margin-top: 5px;
              font-size: var(--font-3xs);
            }
          }

          p:not(.price__tag) span {
            max-width: calc(260px - 160px);
            @include truncate();
          }

          +.top_card_stock_detail {
            align-items: flex-end;
            margin-top: 10px;
          }
        }
      }
    }
  }
}

.predicition-post-card {
  margin-bottom: 15px;
  display: flex;
  justify-content: center;

  &:last-child {
    margin-bottom: 0px;
  }
}

@media screen and (min-width: 1280px) and (max-width: 1891px) {
  .predicition-post-card {
    .prediction-card {
      flex: 0 0 100%;
      width: 100%;

      .firstinfoDv {
        :deep(.stock_logo) {
          background-color: red;
          width: 30px !important;
          flex: 0 0 30px !important;
          height: 30px !important;
          border-width: 2px !important;
          margin-inline-end: 4px !important;
        }
      }

      .OpenDv {
        p {
          font-size: var(--font-3xs);
        }
      }
    }
  }
}
</style>
